// extracted by mini-css-extract-plugin
export default {"snackbar":"styles_snackbar__z+8xy"};